const uk = {
    //calendar
    calendar: {
        monthFull: [
            "Січень",
            "Лютий",
            "Березень",
            "Квітень",
            "Травень",
            "Червень",
            "Липень",
            "Серпень",
            "Вересень",
            "Жовтень",
            "Листопад",
            "Грудень",
        ],
        monthShort: [
            "Січ",
            "Лют",
            "Бер",
            "Квіт",
            "Трав",
            "Черв",
            "Лип",
            "Серп",
            "Вер",
            "Жовт",
            "Лист",
            "Груд",
        ],

        dayFull: [
            "Неділя",
            "Понеділок",
            "Вівторок",
            "Середа",
            "Четвер",
            "П’ятниця",
            "Субота",
        ],

        dayShort: ["Нед", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"],
        hours: "Години",
        minutes: "Хвилини",
        done: "Готово",
        clear: "Очистити",
        today: "Сьогодні",
        am: ["дп", "ДП"],
        pm: ["пп", "ПП"],

        weekStart: 1,
        clockFormat: 24,
    },

    //core
    core: {
        ok: "OK",
        cancel: "Скасувати",
        select: "Вибрати",
        "No data": "Немає даних",
    },

    //formats
    formats: {
        dateFormat: "%d.%m.%Y",
        timeFormat: "%H:%i",
    },

    lang: "uk-UA",

    //Gantt
    gantt: {
        // Header / sidebar
        "Task name": "Назва задачі",
        "Start date": "Дата початку",
        Duration: "Тривалість",
        Task: "Задача",
        Milestone: "Віхa",
        "Summary task": "Зведена задача",

        // Sidebar
        Save: "Зберегти",
        Delete: "Видалити",
        Name: "Назва",
        Description: "Опис",
        "Select type": "Виберіть тип",
        Type: "Тип",
        "End date": "Дата завершення",
        Progress: "Прогрес",
        Predecessors: "Попередники",
        Successors: "Наступники",
        "Add task name": "Додати назву задачі",
        "Add description": "Додати опис",
        "Select link type": "Виберіть тип зв’язку",
        "End-to-start": "Кінець–початок",
        "Start-to-start": "Початок–початок",
        "End-to-end": "Кінець–кінець",
        "Start-to-end": "Початок–кінець",

        // Context menu / toolbar
        Add: "Додати",
        "Child task": "Дочірня задача",
        "Task above": "Задача вище",
        "Task below": "Задача нижче",
        "Convert to": "Перетворити на",
        Edit: "Редагувати",
        Cut: "Вирізати",
        Copy: "Копіювати",
        Paste: "Вставити",
        Move: "Перемістити",
        Up: "Вгору",
        Down: "Вниз",
        Indent: "Збільшити відступ",
        Outdent: "Зменшити відступ",
        "Split task": "Розділити задачу",

        // Toolbar
        "New task": "Нова задача",
        "Move up": "Перемістити вгору",
        "Move down": "Перемістити вниз",
    },
};

export default uk;